import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-50" id="faq">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于送彩金活动的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  {openIndex === index ? (
                    <i className="ri-arrow-up-s-line text-foreground-500"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  )}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}